import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DropDown from '../../../reference-picker-plugin/components/FiltersPanel/FilterComponents/components/DropDown';
import { RFIS_SORTED_STATUSES } from '../../../helpers/statusHelpers';
import { translate } from '../../../helpers';
import { StatusCell } from '../../StatusCell';

const statusOptions = RFIS_SORTED_STATUSES.map((status) => ({
  label: <StatusCell status={status} stacked={false} />,
  value: status,
}));

type SelectedStatus = {
  label: JSX.Element;
  value: string;
};

type StatusDropDownProps = {
  disabled?: boolean;
  selectedStatuses?: string[];
  onChange: (selectedStatuses: SelectedStatus[]) => void;
};

const StatusDropDown = ({ disabled, selectedStatuses, onChange }: StatusDropDownProps) => {
  const [selectedStatusFilters, setSelectedStatusFilters] = useState<SelectedStatus[]>([]);

  useEffect(() => {
    setSelectedStatusFilters(
      statusOptions.filter((status) => selectedStatuses?.includes(status.value)),
    );
  }, [selectedStatuses]);

  return (
    <DropDown
      label={translate('rpPlugin.new.status')}
      value={selectedStatusFilters}
      options={statusOptions}
      disabled={disabled}
      onChange={onChange}
      placeholder={translate('rpPlugin.filter.status')}
    />
  );
};

StatusDropDown.propTypes = {
  disabled: PropTypes.bool,
  selectedStatuses: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
};

StatusDropDown.defaultProps = {
  disabled: false,
};

export default StatusDropDown;
